import {
  EDIT_POLL,
  EDIT_POLL_SUCCESS,
  EDIT_POLL_CLEAN,
  EDIT_POLL_ERROR,
} from "./actionTypes"

const initialState = {
  error: "",
  loading: false,
  done: false,
  poll: undefined,
}

const PollEdit = (state = initialState, action) => {
  switch (action.type) {
    case EDIT_POLL:
      state = {
        ...state,
        loading: true,
      }
      break
    case EDIT_POLL_SUCCESS:
      state = {
        ...state,
        poll: action.payload.poll,
        loading: false,
        done: true,
      }
      break
    case EDIT_POLL_CLEAN:
      state = initialState
      break
    case EDIT_POLL_ERROR:
      state = { ...state, error: action.payload, loading: false, done: false }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default PollEdit
